define('Responsive/util/object',['require','exports','module','./extend'],function(require,exports,module){
	var extend=require('./extend');

	return {
		/**
		 * Create an object that contains the 
		 * top-level differences between two objects.
		 * @param  {object} o1 [description]
		 * @param  {object} o2 [description]
		 * @return {object}    [description]
		 */
		diff : function(o1,o2){
			var key,
				ret={},
				allkeys=this.merge(o1,o2);

			for(key in allkeys){
				ret[key]=o2.hasOwnProperty(key) ? o2[key] : o1[key];
			}
			return ret;
		},

		/**
		 * Very simple non-destructive merge for two objects
		 * @param  {Object} o1 original
		 * @param  {Object} o2 overrides
		 * @return {Object}
		 */
		merge : function (o1,o2){
	        return extend({},o1,o2);
	    },
	    
		/**
		* Non-destructively creates a namespace on a specified object.
		* If no object is specified, uses Responsive. (from Bam.js)
		*
		* Example:
		* Responsive.namespace('widget.MyWidget') // Responsive.widget.MyWidget == {}
		* or...
		* Responsive.namespace('widget').MyWidget = {}; // Responsive.widget.MyWidget == {}
		*
		* @param {Object} obj: to augment with deep namespace
		* @param {String} ns: Dot-delimited namespace
		*/
		namespace : function (obj, ns) {
			var props = (ns || obj).split('.'),
				i, n;

			obj = ns && obj || win.Responsive;
			for (i = 0, n = props.length; i < n; ++i) {
			  obj = obj[props[i]] = obj.hasOwnProperty(props[i]) ? obj[props[i]]||{} : {};
			}
			return obj;
		},
		
		/**
		 * Checks to see if a supplied dot-delimited string of expected children exist under a parent object.
		 * If the child or children do not exist, they are created/appended to each parent (non-destructive).
		 * 
		 * Example:
		 * Responsive.ensureNamespace({ child : { subChild : {} } }, 'child.subChild')
		 * returns { child : { subChild : {} } }
		 * 
		 * Responsive.ensureNamespace({}, 'child.subChild')
		 * returns { child : { subChild : {} } }
		 * 
		 * @param {Object} obj: Object to be augmented
		 * @param {String} contents: Dot-delimited namespace
		 * @returns
		 */
		ensureNamespace : function(obj, contents) {
			obj=obj||{};
			var op=obj;
		    // Check to see if the object has any children before continuing
		    this.namespace(obj,contents)
			return op;
		}
	};
});


